import React, { useState } from "react";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Typography,
  Chip,
} from "@mui/material";
import { Edit as EditIcon } from "@mui/icons-material";
import { useHistory } from "react-router-dom";

const SchDeliveryTable = ({
  deliveries,
  limit,
  setLimit,
  setPage,
  page,
  schdID,
}) => {
  const history = useHistory();
 
  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-IN", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  const formatDateTime = (dateString) => {
    return new Date(dateString).toLocaleString("en-IN", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const handleEdit = (delivery) => {
    console.log("Edit delivery:", delivery.objectId);
    // Add your edit logic here
    history.push(
      `/exam_schedule/delivery/update/${schdID}/${delivery?.objectId}`
    );
  };

  return (
    <Box sx={{ maxWidth: "100%" }}>
      <Paper>
        {/* Header */}

        {/* Table Section */}
        <Paper sx={{ border: "1px solid #e0e0e0" }}>
          <TableContainer>
            <Table>
              <TableHead sx={{ backgroundColor: "#f5f5f5" }}>
                <TableRow>
                  <TableCell sx={{ fontWeight: "bold", color: "#666" }}>
                    Delivery Name
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#666" }}>
                    Date
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#666" }}>
                    Class
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#666" }}>
                    Created at
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#666" }}>
                    Created by
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#666" }}>
                    Updated at
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#666" }}>
                    Updated on
                  </TableCell>
                  <TableCell sx={{ fontWeight: "bold", color: "#666" }}>
                    Actions
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {deliveries.map((delivery, index) => (
                  <TableRow
                    key={delivery.objectId}
                    sx={{
                      "&:nth-of-type(odd)": { backgroundColor: "#fafafa" },
                      "&:hover": { backgroundColor: "#f0f0f0" },
                    }}
                  >
                    <TableCell>
                      <Box>
                        <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                          {delivery.label}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          {delivery.chapterName}
                        </Typography>
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2">
                        {formatDate(delivery.startDateTime)}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        {new Date(delivery.startDateTime).toLocaleTimeString(
                          "en-IN",
                          {
                            hour: "2-digit",
                            minute: "2-digit",
                          }
                        )}{" "}
                        -{" "}
                        {new Date(delivery.endDateTime).toLocaleTimeString(
                          "en-IN",
                          {
                            hour: "2-digit",
                            minute: "2-digit",
                          }
                        )}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      {delivery?.Class?.length > 0
                        ? delivery.Class.map((cls, index) => (
                            <Chip
                              key={index}
                              label={`${cls.name}`}
                              size="small"
                              color="primary"
                              variant="outlined"
                            />
                          ))
                        : null}
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2">
                        {formatDateTime(delivery.createdAt)}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2">
                        {delivery.CreatedUserName}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2">
                        {formatDateTime(delivery.updatedAt)}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Typography variant="body2">
                        {formatDate(delivery.updatedAt)}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Button
                        variant="outlined"
                        size="small"
                        startIcon={<EditIcon />}
                        onClick={() => handleEdit(delivery)}
                        sx={{ borderColor: "#7c4dff", color: "#7c4dff" }}
                      >
                        Edit
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </Paper>
    </Box>
  );
};

export default SchDeliveryTable;
